import './App.css';
import React from "react";
import { BrowserRouter, Navigate, Routes, Route, useLocation } from "react-router-dom";

import Onaylananlar from "./Onaylananlar";
import OnayBekleyenler from "./OnayBekleyenler";
import IptalEdilenler from "./IptalEdilenler";
import Tamamlananlar from "./Tamamlananlar";
import Musteriler from "./Musteriler";
import Makineler from "./Makineler";
import Layout from "./Layout";
import ModernLayout from "./yeni/ModernLayout";
import TumTeklifler from "./TumTeklifler";
import SevkEdilenler from "./SevkEdilenler";
import Hazirlananlar from "./Hazirlananlar";
import TaskTable from "./TaskTable";
import IsEmirleriTaslaklar from "./IsEmirleriTaslaklar";
import IsEmirleriOnayli from "./IsEmirleriOnayli";
import IsEmirleriIptaller from "./IsEmirleriIptaller";
import IsEmirleriDevam from "./IsEmirleriDevam";
import IsEmirleriPasifDevam from "./IsEmirleriPasifDevam";
import IsEmirleriTamamlanan from "./IsEmirleriTamamlanan";
import TaskTableV2 from "./TaskTableV2";
import MachineLocationChange from "./MachineLocationChange";
import KirmiziDefter from "./KirmiziDefter";
import TumIsEmirleri from "./TumIsEmirleri";
import IzinListesi from "./IzinListesi";
import IsEmirleriTalepler from "./IsEmirleriTalepler";
import TaskTableGeneral from "./TaskTableGeneral";
import VizeKayitForm from "./Components/VizeKayitForm";
import VizeListesi from "./VizeListesi";
import SatisOzetGrafik from "./SatisOzetGrafik";
import SozlesmelerOnayli from "./SozlemelerOnayli";
import TeklifSatisRaporu from "./TeklifSatisRaporu";
import IsEmriMalzemeEkle from "./IsEmriMalzemeEkle";
import TeklifKopyala from "./TeklifKopyala";
import OdemeTakipRaporu from "./OdemeTakipRaporu";
import TeklifSatisRaporuDetay from "./TeklifSatisRaporuDetay";
import IsEmriTalepForm from "./IsEmriTalepForm";
import Pano from "./Pano";
import KullaniciYonetimi from "./KullaniciYonetimi";
import Login from "./Login";
import RequireAuth from "./RequireAuth";
import { AuthProvider } from "./AuthContext";

function YeniRedirect() {
  const location = useLocation();
  const next = location.pathname.replace(/^\/yeni/, "") || "/";
  return <Navigate to={`${next}${location.search}`} replace />;
}

class App extends React.Component {
  render() {
    return (
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<RequireAuth />}>
              <Route path="/yeni" element={<Navigate to="/" replace />} />
              <Route path="/yeni/*" element={<YeniRedirect />} />
              <Route path="/" element={<ModernLayout />}>
                <Route index element={<Pano />} />
                <Route path="tum-teklifler" element={<TumTeklifler />} />
                <Route path="onaylananlar" element={<Onaylananlar />} />
                <Route path="hazirlananlar" element={<Hazirlananlar />} />
                <Route path="onay-bekleyenler" element={<OnayBekleyenler />} />
                <Route path="tamamlananlar" element={<Tamamlananlar />} />
                <Route path="sevk-edilenler" element={<SevkEdilenler />} />
                <Route path="iptal-edilenler" element={<IptalEdilenler />} />
                <Route path="teklif-satis-raporu" element={<TeklifSatisRaporu />} />
                <Route path="detayli-teklif-satis-raporu" element={<TeklifSatisRaporuDetay />} />
                <Route path="satis-grafikleri" element={<SatisOzetGrafik />} />
                <Route path="musteri-listele" element={<Musteriler />} />
                <Route path="makine-listele" element={<Makineler />} />
                <Route path="task-table" element={<TaskTable />} />
                <Route path="tum-is-emirleri" element={<TumIsEmirleri />} />
                <Route path="taslak-is-emirleri" element={<IsEmirleriTaslaklar />} />
                <Route path="talep-is-emirleri" element={<IsEmirleriTalepler />} />
                <Route path="onayli-is-emirleri" element={<IsEmirleriOnayli />} />
                <Route path="iptal-is-emirleri" element={<IsEmirleriIptaller />} />
                <Route path="devam-eden-is-emirleri" element={<IsEmirleriDevam />} />
                <Route path="pasif-devam-is-emirleri" element={<IsEmirleriPasifDevam />} />
                <Route path="tamamlanan-is-emirleri" element={<IsEmirleriTamamlanan />} />
                <Route path="izin-listesi" element={<IzinListesi />} />
                <Route path="is-emirleri-takvimi" element={<TaskTable />} />
                <Route path="genel-takvim" element={<TaskTableGeneral />} />
                <Route path="gunluk" element={<TaskTableV2 />} />
                <Route path="makine-lokasyon-guncelle" element={<MachineLocationChange />} />
                <Route path="kirmizi-defter" element={<KirmiziDefter />} />
                <Route path="vize-kaydet" element={<VizeKayitForm />} />
                <Route path="vize-listesi" element={<VizeListesi />} />
                <Route path="onayli-sozlesmeler" element={<SozlesmelerOnayli />} />
                <Route path="teklif-olustur" element={<IsEmriMalzemeEkle />} />
                <Route path="teklif-olustur/:teklif_no" element={<IsEmriMalzemeEkle />} />
                <Route path="teklif-kopyala/:teklif_no" element={<TeklifKopyala />} />
                <Route path="teklif-revize/:teklif_no" element={<TeklifKopyala mode="revize" />} />
                <Route path="talep-ekle" element={<IsEmriTalepForm createMode />} />
                <Route path="is-emri-duzenle/:is_emri_no/:redirect" element={<IsEmriTalepForm />} />
                <Route path="talep-is-emri-duzenle/:is_emri_no/:redirect" element={<IsEmriTalepForm />} />
                <Route path="odeme-takip-raporu" element={<OdemeTakipRaporu />} />
                <Route path="kullanici-yonetimi" element={<KullaniciYonetimi />} />
              </Route>
              <Route path="/eski" element={<Layout />}>
                <Route index element={<Pano />} />
                <Route path="tum-teklifler" element={<TumTeklifler />} />
                <Route path="onaylananlar" element={<Onaylananlar />} />
                <Route path="hazirlananlar" element={<Hazirlananlar />} />
                <Route path="onay-bekleyenler" element={<OnayBekleyenler />} />
                <Route path="tamamlananlar" element={<Tamamlananlar />} />
                <Route path="sevk-edilenler" element={<SevkEdilenler />} />
                <Route path="iptal-edilenler" element={<IptalEdilenler />} />
                <Route path="teklif-satis-raporu" element={<TeklifSatisRaporu />} />
                <Route path="detayli-teklif-satis-raporu" element={<TeklifSatisRaporuDetay />} />
                <Route path="satis-grafikleri" element={<SatisOzetGrafik />} />
                <Route path="musteri-listele" element={<Musteriler />} />
                <Route path="makine-listele" element={<Makineler />} />
                <Route path="task-table" element={<TaskTable />} />
                <Route path="tum-is-emirleri" element={<TumIsEmirleri />} />
                <Route path="taslak-is-emirleri" element={<IsEmirleriTaslaklar />} />
                <Route path="talep-is-emirleri" element={<IsEmirleriTalepler />} />
                <Route path="onayli-is-emirleri" element={<IsEmirleriOnayli />} />
                <Route path="iptal-is-emirleri" element={<IsEmirleriIptaller />} />
                <Route path="devam-eden-is-emirleri" element={<IsEmirleriDevam />} />
                <Route path="pasif-devam-is-emirleri" element={<IsEmirleriPasifDevam />} />
                <Route path="tamamlanan-is-emirleri" element={<IsEmirleriTamamlanan />} />
                <Route path="izin-listesi" element={<IzinListesi />} />
                <Route path="is-emirleri-takvimi" element={<TaskTable />} />
                <Route path="genel-takvim" element={<TaskTableGeneral />} />
                <Route path="gunluk" element={<TaskTableV2 />} />
                <Route path="makine-lokasyon-guncelle" element={<MachineLocationChange />} />
                <Route path="kirmizi-defter" element={<KirmiziDefter />} />
                <Route path="vize-kaydet" element={<VizeKayitForm />} />
                <Route path="vize-listesi" element={<VizeListesi />} />
                <Route path="onayli-sozlesmeler" element={<SozlesmelerOnayli />} />
                <Route path="teklif-olustur" element={<IsEmriMalzemeEkle />} />
                <Route path="teklif-olustur/:teklif_no" element={<IsEmriMalzemeEkle />} />
                <Route path="teklif-kopyala/:teklif_no" element={<TeklifKopyala />} />
                <Route path="teklif-revize/:teklif_no" element={<TeklifKopyala mode="revize" />} />
                <Route path="talep-ekle" element={<IsEmriTalepForm createMode />} />
                <Route path="is-emri-duzenle/:is_emri_no/:redirect" element={<IsEmriTalepForm />} />
                <Route path="talep-is-emri-duzenle/:is_emri_no/:redirect" element={<IsEmriTalepForm />} />
                <Route path="odeme-takip-raporu" element={<OdemeTakipRaporu />} />
                <Route path="kullanici-yonetimi" element={<KullaniciYonetimi />} />
              </Route>
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    );
  }
}

export default App;
